import React from 'react';
import { object, func, bool, string } from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {
  withStyles,
  MuiThemeProvider,
  createTheme,
} from '@material-ui/core/styles';
import { Translation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import Recaptcha from 'react-recaptcha';
import RegistrationError from '../../scenes/Registration/RegistrationError';

const styles = (theme) => ({
  textFielde: {
    marginTop: theme.spacing(1),
    marginBottom: 0,
  },
  button: {
    marginTop: theme.spacing(2),
    backgroundColor: '#357a38',
    color: '#ffffff',
    fontWeight: '600',
  },
  linkButton: {
    marginTop: theme.spacing(2),
  },
  root: {},
  headerContainer: {},
  titleStyle: {},
  subTitle: {},
  itemMidContainer: {},
  footerContainer: {},
  footerBar: {},
  textFooterTerms: {},
  textFooter: {},
  trademarkText: {},
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#6fbf73',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f50057',
      contrastText: '#ffffff',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

function verifyCaptcha(response) {
  console.log('captcha verified: ', response);
}

function UserRegistration(props) {
  const {
    classes,
    email,
    confirmEmail,
    password,
    confirmPassword,
    emailError,
    confirmEmailError,
    passwordError,
    confirmPasswordError,
    isSigningUp,
    signup,
    signupError,
    emailChanged,
    confirmEmailChanged,
    passwordChanged,
    confirmPasswordChanged,
    canSignup,
    history,
  } = props;
  return signupError ? (
    <RegistrationError />
  ) : (
    <Translation>
      {(t) => {
        return (
          <form
            onSubmit={(event) => {
              event.preventDefault();
              signup(history);
            }}
          >
            <div>
              <TextField
                id="login-email"
                name="email"
                label={t('email')}
                autoComplete="email"
                value={email}
                onChange={(event) => emailChanged(event.target.value)}
                className={classes.textField}
                fullWidth
                error={emailError.length > 0}
                disabled={isSigningUp}
              />
            </div>
            <div>
              <TextField
                id="confirm-email"
                name="confirmEmail"
                label={t('confimEmailAddress')}
                autoComplete="email"
                value={confirmEmail}
                onChange={(event) => confirmEmailChanged(event.target.value)}
                className={classes.textField}
                fullWidth
                error={confirmEmailError.length > 0}
                disabled={isSigningUp}
              />
            </div>
            <div>
              <TextField
                id="login-password"
                label={t('password')}
                autoComplete="current-password"
                type="password"
                value={password}
                onChange={(event) => passwordChanged(event.target.value)}
                className={classes.textField}
                fullWidth
                error={passwordError.length > 0}
                disabled={isSigningUp}
              />
            </div>
            <div>
              <TextField
                id="confirm-password"
                label={t('confimPassword')}
                autoComplete="current-password"
                type="password"
                value={confirmPassword}
                onChange={(event) => confirmPasswordChanged(event.target.value)}
                className={classes.textField}
                fullWidth
                error={confirmPasswordError.length > 0}
                disabled={isSigningUp}
              />
            </div>
            <Recaptcha
              sitekey="6LcGbnoUAAAAAL607enKUeZr-RsqHqkA0OB3urok"
              verifyCallback={verifyCaptcha}
            />
            <div>
              <MuiThemeProvider theme={theme}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={classes.button}
                  fullWidth
                  disabled={isSigningUp || !canSignup}
                >
                  {t('register')}
                </Button>
              </MuiThemeProvider>
            </div>
            <div className={classes.linkButton}>
              <Link to="/login">
                <Typography color="primary" variant="subtitle1">
                  {t('alreadyRegistered')}
                </Typography>
              </Link>
            </div>
          </form>
        );
      }}
    </Translation>
  );
}

UserRegistration.propTypes = {
  classes: object.isRequired,
  email: string.isRequired,
  confirmEmail: string.isRequired,
  emailError: string.isRequired,
  confirmEmailError: string.isRequired,
  password: string.isRequired,
  passwordError: string.isRequired,
  confirmPassword: string.isRequired,
  confirmPasswordError: string.isRequired,
  signup: func.isRequired,
  signupError: string,
  emailChanged: func.isRequired,
  passwordChanged: func.isRequired,
  confirmEmailChanged: func.isRequired,
  confirmPasswordChanged: func.isRequired,
  isSigningUp: bool.isRequired,
  canSignup: bool.isRequired,
};

export default withStyles(styles)(UserRegistration);



// WEBPACK FOOTER //
// ./src/view/forms/UserRegistration/UserRegistration.js